import React from 'react'
import PropTypes from 'prop-types'

const IconArrow = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24">
    <path d="M20.513 13.233H1.003A.999.999 0 0 1 0 12.238c0-.55.449-.995 1.003-.995h19.99L13.392 3.7a.99.99 0 0 1 0-1.408 1.008 1.008 0 0 1 1.418 0l8.897 8.83a.99.99 0 0 1 .278.879.99.99 0 0 1-.278.88l-8.897 8.829a1.008 1.008 0 0 1-1.418 0 .99.99 0 0 1 0-1.408l7.122-7.068z" />
  </svg>
)

IconArrow.propTypes = {
  className: PropTypes.string.isRequired,
}

export default IconArrow
